import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const LAST_UPDATED = "18 January 2026";

const PrivacyPolicy: React.FC = () => {
  return (
    <Container className="my-5 text-white">
      {/* Header */}
      <Row className="mb-4">
        <Col lg={10}>
          <h1 className="fw-bold mb-2">Privacy Policy</h1>
          <p className="mb-0">
            Your privacy matters to us. This policy explains how Bartollini Pizza
            collects and uses your personal data.
          </p>
          <small>Last updated: {LAST_UPDATED}</small>
        </Col>
      </Row>

      {/* Privacy Policy Content */}
      <Row>
        <Col lg={12}>
          <section>
            <h2 className="h4 fw-semibold mb-3">1. Who We Are</h2>
            <p>
              Bartollini Pizza is a mobile wood-fired pizza catering business
              operating in Ireland. For GDPR purposes, Bartollini Pizza is the
              data controller of your personal data. If you have any questions
              about this Privacy Policy or how your data is handled, you can
              contact us at bartollinipizza@gmail.com.
            </p>

            <h2 className="h4 fw-semibold mt-4 mb-3">
              2. What Personal Data We Collect
            </h2>
            <p>When you submit an enquiry or booking request, we may collect:</p>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Event details (date, location, number of guests, notes)</li>
            </ul>
            <p>
              We only collect data that is necessary to respond to your enquiry
              or provide our services.
            </p>

            <h2 className="h4 fw-semibold mt-4 mb-3">
              3. How We Use Your Data
            </h2>
            <ul>
              <li>To respond to event enquiries</li>
              <li>To communicate about bookings</li>
              <li>To provide quotes and confirm event details</li>
              <li>To manage business operations related to your enquiry</li>
            </ul>
            <p>
              We do not use your data for marketing purposes unless you
              explicitly agree to it.
            </p>

            <h2 className="h4 fw-semibold mt-4 mb-3">
              4. Legal Basis for Processing
            </h2>
            <ul>
              <li>
                <strong>Consent:</strong> when you submit a booking or enquiry
                and agree to this Privacy Policy
              </li>
              <li>
                <strong>Legitimate Interest:</strong> to respond to your enquiry
                and provide requested services
              </li>
            </ul>

            <h2 className="h4 fw-semibold mt-4 mb-3">
              5. How We Store and Protect Your Data
            </h2>
            <ul>
              <li>Your data is stored securely in our internal systems</li>
              <li>Access is limited to authorised persons only</li>
              <li>
                We use reasonable technical and organisational measures to
                protect your data
              </li>
              <li>
                We may use trusted service providers (e.g. website hosting and
                database hosting) to process data on our behalf.
              </li>
            </ul>

            <h2 className="h4 fw-semibold mt-4 mb-3">
              6. How Long We Keep Your Data
            </h2>
            <p>
              We keep your data only for as long as necessary to manage enquiries
              and bookings, or where required for legal or accounting purposes.
              You may request deletion at any time.
            </p>

            <h2 className="h4 fw-semibold mt-4 mb-3">
              7. Sharing Your Data
            </h2>
            <p>
              We do not sell, rent, or trade your personal data. Data will only
              be shared if required by law or to protect our legal rights.
            </p>

            <h2 className="h4 fw-semibold mt-4 mb-3">
              8. Your GDPR Rights
            </h2>
            <ul>
              <li>Access your personal data</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to or restrict processing</li>
              <li>Withdraw consent at any time</li>
            </ul>
            <p>
              To exercise these rights, contact us at
              bartollinipizza@gmail.com.
            </p>

            <h2 className="h4 fw-semibold mt-4 mb-3">9. Cookies</h2>
            <p>
              Our website does not use cookies for tracking or advertising
              purposes. If this changes, this policy will be updated.
            </p>

            <h2 className="h4 fw-semibold mt-4 mb-3">
              10. Changes to This Policy
            </h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page.
            </p>

            <h2 className="h4 fw-semibold mt-4 mb-3">11. Governing Law</h2>
            <p>
              This Privacy Policy is governed by the laws of Ireland and the
              General Data Protection Regulation (GDPR).
            </p>
          </section>
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicy;
